var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bulletPoints.length)?_c('div',{staticClass:"product-bulletpoints"},[_c('ul',{staticClass:"bulletpoints"},_vm._l((_vm.bulletPoints),function(row,index){return _c('li',{key:index},[(row.content)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.generate(row.content))}}):_vm._e()])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }